"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function isObject(v) {
    return (typeof v === 'object' && !Array.isArray(v));
}
function merge2(a, b) {
    return (isObject(a) && isObject(b)
        ? __assign(__assign({}, a), Object.fromEntries(Object.entries(b).map(function (_a) {
            var k = _a[0], v = _a[1];
            return [k, merge2(a[k], v)];
        }))) : b);
}
function merge() {
    var objs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objs[_i] = arguments[_i];
    }
    if (objs.length < 2)
        return objs[0];
    return merge2(objs[0], merge.apply(void 0, objs.slice(1)));
}
exports.default = merge;
//# sourceMappingURL=merge.js.map